export const MATCH_ESCAPED_VARIABLES = '{(.*?)}' as const;
